var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questions-list-item"},[(!_vm.heading.includes('clauses.clause'))?_c('h3',[_vm._v(_vm._s(_vm.heading))]):_c('div',{staticClass:"block-xl"}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }